/* eslint-disable */

import Sloth from '../Sloth';
import $ from 'jquery';
import flashpath from './jwplayer/jwplayer.flash.swf';

@Sloth.component({
    defaultOptions : {
        primary : 'flash',
        width : '100%',
        height : '200',
        aspectratio: '16:9'
    }
})

export default class Video {
    onInit() {
        const dom = this.dom;
        const options = this.options;

        require.ensure(['exports?jwplayer!./jwplayer', 'exports?jwplayer!./jwplayer/jwplayer.html5.js'], () => {
            var jwplayer = require('exports?jwplayer!./jwplayer');
            jwplayer = require('exports?jwplayer!./jwplayer/jwplayer.html5.js');

            const id = `video${Math.floor(Math.random() * 100000)}`;
            $(dom).attr('id', id);

            jwplayer(id).setup({
                flashplayer : flashpath,
                primary     : options.primary,
                image       : options.image,
                file        : options.file,
                width       : options.width,
                height      : options.height,
                aspectratio : options.aspectratio
            });
        });
    }
}




/** WEBPACK FOOTER **
 ** ./components/Video/video.js
 **/